<template>
    <v-container>
        <SelectorAgenda :disabled="cargandoListaIndicadores"></SelectorAgenda>
        <v-row>
            <v-col cols="12">
                <div class="titulo my-4 px-4">
                    <h1 class="font-weight-bold" :class="esMovil ? 'text-h6' : 'text-h5'">
                        {{ titulo }}
                    </h1>
                </div>
                <v-row
                    justify="center"
                    v-for="(listaEnlacesObjetivos, index) in listaIndicadoresDividida"
                    :key="index"
                    class="px-4"
                >
                    <v-avatar
                        v-for="enlace in listaEnlacesObjetivos"
                        :key="enlace.texto"
                        class=""
                        size="56"
                        :class="[
                            id === undefined || id == enlace.id ? '' : 'disabled',
                            esMovil ? 'my-3 mx-auto' : 'ma-3',
                        ]"
                        @click="linkToObjectivo(enlace)"
                    >
                        <v-img :src="enlace.icono" max-width="60"> </v-img>
                    </v-avatar>
                </v-row>
            </v-col>
        </v-row>
        <ListaIndicadores
            v-if="listaIndicadores.length > 0"
            :listaIndicadores="listaIndicadores"
            :esUltimaPagina="esUltimaPagina"
            @cargarMasIndicadores="scrollInfinito"
        ></ListaIndicadores>
        <v-row justify="center" v-else>
            <v-col v-if="cargandoListaIndicadores" cols="12" class="text-center">
                <v-progress-circular
                    size="50"
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-col>
            <v-col v-else cols="12">
                <v-card>
                    <v-card-text>
                        {{ $t("detalles.texto.no-hay-indicadores") }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import ListaIndicadores from "@components/ListaIndicadores.vue";
import SelectorAgenda from "@components/SelectorAgenda.vue";
import IndicadoresService from "@services/IndicadoresService.js";
import MasterdataService from "@services/MasterdataService";

export default {
    name: "listadoIndicadores",
    props: ["id"],
    components: {
        ListaIndicadores,
        SelectorAgenda,
    },
    data: () => ({
        enlacesObjetivos: [],
        pagina: 1,
        ultimaPagina: 10,
        listaIndicadores: [],
        cargandoListaIndicadores: false,
        timeout: null,
    }),
    computed: {
        titulo() {
            return this.id && this.enlacesObjetivos.length > 0
                ? this.$t(this.enlacesObjetivos[this.id - 1].texto)
                : this.$t("lista-indicadores.texto.titulo-defecto");
        },
        listaIndicadoresDividida() {
            return this.esMovil
                ? [this.enlacesObjetivos.slice(0, 5), this.enlacesObjetivos.slice(5)]
                : [this.enlacesObjetivos];
        },
        esUltimaPagina() {
            return this.pagina >= this.ultimaPagina;
        },
        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    methods: {
        linkToObjectivo(enlace) {
            let direccion =
                enlace.id == this.id ? { name: "listado-indicadores" } : enlace.link;
            direccion.query = this.$route.query;

            this.$router.push(direccion);
        },
        recargarLista() {
            this.pagina = 1;
            this.ultimaPagina = 10;
            this.listaIndicadores = [];
            this.actualizarListaIndicadores();
        },

        cambiarFiltro() {
            this.recargarLista();
        },

        actualizarListaIndicadores() {
            if (this.cargandoListaIndicadores) {
                return;
            }

            let params = {
                page: this.pagina,
                idObjetivo: this.id,
                filtroAgenda: this.$route.query.filtroAgenda,
            };

            this.cargandoListaIndicadores = true;
            IndicadoresService.getIndicadores(params)
                .then((response) => {
                    this.ultimaPagina = response.data.last_page;
                    response.data.data.forEach((indicador) =>
                        this.listaIndicadores.push(indicador)
                    );
                })
                .catch((error) => {
                    this.pagina = 1;
                    this.ultimaPagina = 1;
                    this.listaIndicadores = [];
                })
                .finally(() => {
                    this.cargandoListaIndicadores = false;
                });
        },

        //Carga mas indicadores cuando se llega al final de la pagina
        scrollInfinito() {
            if (this.esUltimaPagina || this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.pagina++;
                this.actualizarListaIndicadores();
            }, 1000);
        },
    },

    watch: {
        id(nuevoId) {
            this.recargarLista();
        },
        "$route.query.filtroAgenda"() {
            this.cambiarFiltro();
        },
    },

    mounted() {
        MasterdataService.getEnlacesObjetivos().then((response) => {
            this.enlacesObjetivos = response.data.objetivos.map((objetivo) => ({
                ...objetivo,
                texto: this.$t(objetivo.texto),
            }));
        });
        this.actualizarListaIndicadores();
    },
};
</script>

<style scoped></style>
